import styled from 'styled-components';
import media from 'styled-media-query';

export const Container = styled.div`
  justify-content: center;
  display: grid;
  justify-items: center;
  gap: 1rem 3rem;
  margin: auto;
  ${media.lessThan('large')`
    gap: 1rem;
    margin-top: 2rem;
  `}
  max-width: 80rem;
`;
export const Main = styled.main`
  width: 100%;
  grid-area: main;
`;
export const Title = styled.h1`
  grid-area: title;
  ${media.lessThan('small')`
    font-size: 1.5rem;
  `}
  margin: 0;
`;
